import BaseHelper from 'ember-intl/helpers/format-number';

/**
 * Helper per formattare numeri con supporto per valori vuoti
 */
class FormatNumberHelper extends BaseHelper {
  constructor(...args) {
    super(...args);
    this.allowEmpty = true;
  }
}

export { FormatNumberHelper as default };
//# sourceMappingURL=format-number.js.map
